module.exports = __webpack_public_path__ + "media/logos/kroger-b442cd1a.png";